import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { AdminAccount, AdminAccountListResponse, CreateAdminInput } from './types';

const KEY = ['admin-accounts'];

export function use_admin_accounts(q: string, from?: string, to?: string) {
  return useQuery({
    queryKey: [...KEY, q, from ?? '', to ?? ''],
    queryFn: async () => {
      const res = await api.get<AdminAccountListResponse>('/admin/admins', {
        params: {
          ...(q.trim() ? { q: q.trim() } : {}),
          ...(from ? { from } : {}),
          ...(to ? { to } : {}),
        },
      });
      return res.data;
    },
  });
}

export function use_create_admin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: CreateAdminInput) => {
      const res = await api.post<AdminAccount>('/admin/admins', input);
      return res.data;
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function use_set_admin_active() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, is_active }: { id: string; is_active: boolean }) => {
      const res = await api.post<AdminAccount>(
        `/admin/admins/${id}/${is_active ? 'reactivate' : 'deactivate'}`,
      );
      return res.data;
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: KEY }),
  });
}
